var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmIcon03(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_184",
    "data-name": "Group 184",
    transform: "translate(-859 -3145)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_179",
    "data-name": "Group 179",
    transform: "translate(-77 1731)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_28",
    "data-name": "Ellipse 28",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(936 1414)",
    fill: "#ff6a00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26856",
    "data-name": "Path 26856",
    d: "M43.478-33.018a3.393,3.393,0,0,0-3.26-3.511H31.882a3.393,3.393,0,0,0-3.26,3.511v4.178a3.393,3.393,0,0,0,3.26,3.511h8.336a3.393,3.393,0,0,0,3.26-3.511Zm-4.9,2.4-3.738,1.992c-.147.085-.644-.029-.644-.209v-4.088c0-.182.5-.3.649-.206l3.578,2.1C38.57-30.939,38.728-30.7,38.576-30.616Z",
    transform: "translate(916.378 1460.529)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmIcon03);
export default __webpack_public_path__ + "static/media/sm-icon-03.07b2dbb52d06774323998999dfea781f.svg";
export { ForwardRef as ReactComponent };